import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {Stack} from '@mui/material';

import {getOpenItem} from '../../../../app/store/reducers/menu';
import {getIsStakeAdmin, getTeamMemberRole} from '../../../../app/store/reducers/session';
import PortfolioTab from './Portfolio/PortfolioTab';
import CommunityTab from './Community/CommunityTab';
import CampaignTab from './Campaign/CampaignTab';
import {ReportsTable} from './Reports/ReportsTable';

const TodayTab = () => {
    const params = useParams();
    const accountSfid = params?.account_sfid;

    const openItem = useSelector(getOpenItem);
    const isStakeAdmin = useSelector(getIsStakeAdmin);
    const userRole = useSelector(getTeamMemberRole);

    const activeComponent = useMemo(() => {
        switch (openItem) {
            case 'communities':
                return <CommunityTab />;
            case 'campaigns':
                return <CampaignTab />;
            default:
                return <PortfolioTab />;
        }
    }, [openItem]);

    return (
        <Stack direction="column" rowGap={3} sx={{width: '100%'}}>
            <div>{activeComponent}</div>
            {(isStakeAdmin ||
                (['0014S000004aYHhQAM', '0014S000004bx6LQAQ'].includes(accountSfid) &&
                    ['Administrator', 'Regional Property Manager'].includes(userRole))) && <ReportsTable />}
        </Stack>
    );
};

export default TodayTab;
